var ADMIN_EMAIL = 'admin@budeesolutions.com';
var USER_STATUS = {
  SUPERADMIN: 'superadmin',
  SUPERVISOR: 'supervisor',
  BASIC: 'basic',
  WELLNESS: 'wellness'
};
var PRIVILEGED_USER = [USER_STATUS.SUPERADMIN, USER_STATUS.SUPERVISOR];
var ALL_PRIVILEGED_USER = [USER_STATUS.SUPERADMIN];
var USER_PICTURES = {
  PROFILE: 'profile',
  PERSONAL: 'personal'
};
var ENTITIES = {
  USER: 'User',
  AFFILIATION: 'Affiliation',
  PICTURES: 'Pictures',
  VACCINATION: 'Vaccination',
  TOKEN: 'Token',
  COMPANY: 'Company',
  PROJECT: 'Project',
  ROLES: 'Roles',
  SUPERVISOR: 'Supervisor',
  DEPARTMENTS: 'Departments',
  PERSONNEL: 'Personnel',
  PROJECT_CERTIFICATION: 'ProjectCertification',
  COMPANY_CERTIFICATION: 'CompanyCertification',
  CERTIFICATION: 'Certification',
  NOTIFICATION: 'Notification',
  PROJECT_NOTIFICATION: 'ProjectNotification',
  SUBMISSION: 'Submission',
  DRUGS: 'Drugs',
  ALCOHOL: 'Alcohol',
  MOOD: 'Mood',
  COVID: 'Covid',
  SLEEP: 'Sleep',
  ALCOHOL_CONFIG: 'AlcoholConfig',
  COVID_CONFIG: 'CovidConfig',
  MOOD_CONFIG: 'MoodConfig',
  SLEEP_CONFIG: 'SleepConfig',
  DRUGS_CONFIG: 'DrugsConfig',
  LOCATION: 'Location',
  LOGIN: 'Login',
  ALCOHOL_RESULT: 'ResultAlcohol',
  CERTIFICATION_RESULT: 'ResultCertification',
  DRUGS_RESULT: 'ResultDrugs',
  MOOD_RESULT: 'ResultMood',
  COVID_RESULT: 'ResultCovid',
  SLEEP_RESULT: 'ResultSleep',
  CHECKIN: 'CheckIn',
  SIGN_UP: 'SignUp',
  LICENSE: 'License',
  INVOICE: 'Invoice',
  LINE_ITEM: 'LineItem',
  ADMINISTRATOR: 'Administrator',
  REWARD: 'Reward',
  REWARD_PARTICIPANT: 'RewardParticipant',
  WEATHER_ALERT: 'WeatherAlert',
  PROGRAM: 'Program',
  RECEIPT: 'Receipt',
  DOCUMENT: 'Document',
  DOCUMENT_FIELD: 'DocumentField',
  DOCUMENT_SUBMISSION: 'DocumentSubmission',
  DOCUMENT_SUBMISSION_ATTACHMENT: 'DocumentSubmissionAttachment',
  DOCUMENT_VALUE: 'DocumentValue',
  DOCUMENT_READONLY: 'DocumentReadOnly',
  DOCUMENT_UPLOAD: 'DocumentUpload',
  DOCUMENT_SIGNATURE: 'DocumentSignature',
  READ_DOCUMENT: 'ReadDocument',
  SAFETY_OBSERVATION: 'SafetyObservation',
  CONTRACTORS: 'Contractors',
  QUIZ: 'Quiz',
  QUIZ_QUESTION: 'QuizQuestion',
  QUIZ_SUBMISSION: 'QuizSubmission',
  QUIZ_ANSWER: 'QuizAnswer'
};
var STATUS = {
  GREEN: 0,
  YELLOW: 1,
  RED: 2
};
var DASS_STATUS = {
  NORMAL: 0,
  MILD: 1,
  MODERATE: 2,
  SEVERE: 3,
  EXTREME: 4
};
var INTERACTIONS = {
  MINOR: 'minor',
  MODERATE: 'moderate',
  MAJOR: 'major'
};
var SLEEP_CONFIG = {
  quality: 3,
  hours: 7
};
var DRUG_CONFIG = {
  adverseEffects: {
    yellow: [],
    red: []
  },
  blackboxWarnings: {
    yellow: [],
    red: []
  },
  interactions: {
    minor: 0,
    moderate: 1,
    major: 2
  }
};
var COVID_CONFIG = {
  primarySymptoms: {
    yellow: 1,
    red: 1
  },
  secondarySymptoms: {
    yellow: 1,
    red: 2
  },
  temperature: false,
  vaccination: false,
  bypass: false,
  imageRequired: false
};
var DEFAULT_PREFERENCES = {
  alcohol: true,
  certificationExpires: 30,
  covid: true,
  drugs: true,
  mood: true,
  sleep: true
};
var METRIC = 'Metric';
var IMPERIAL = 'Imperial';
var OPERATIONS = {
  NOTIFICATIONS: {
    CREATE: 'createNotification',
    READ: 'getNotifications'
  }
};
var RECEIPT_STATUS = {
  AWAITING: 'AWAITING',
  PROCESSED: 'PROCESSED'
};
var DAYS = 365;
var BILLING = {
  INVOICE_UNPAID: 'UNPAID',
  INVOICE_PAID: 'PAID'
};
var ADD = 'add';
var REMOVE = 'remove';
var ACTIVE = 'ACTIVE';
var INACTIVE = 'INACTIVE';
var NOTIFICATIONS = {
  ALERT: 'Alert',
  CERTIFICATION: 'Certification',
  WEATHER: 'Weather',
  CERTIFICATION_SUBMISSION: 'CertificationSubmission',
  SAFETY_OBSERVATION: 'SafetyObservation',
  DOCUMENT_SUBMISSION: 'DocumentSubmission',
  DOCUMENT_UPLOAD: 'DocumentUpload',
  DOCUMENT_SIGNATURE: 'DocumentSignature',
  DOCUMENT_SIGNATURE_COMPLETED: 'DocumentSignatureCompleted',
  DOCUMENT_READONLY: 'DocumentReadOnly',
  REWARD: 'Reward',
  PROGRAM: 'Program',
  NEW_USER: 'NewUser'
};
var DOCUMENTS = {
  FIELDS: {
    DATE: {
      ID: 'date',
      TEXT: 'Date'
    },
    DIVIDER: {
      ID: 'divider',
      TEXT: 'Divider'
    },
    TEXT: {
      ID: 'text',
      TEXT: 'Text Input'
    },
    TEXTAREA: {
      ID: 'textarea',
      TEXT: 'Text Area'
    },
    USER: {
      ID: 'user',
      TEXT: 'User'
    },
    USER_LIST: {
      ID: 'user_list',
      TEXT: 'User List'
    },
    TEXT_LIST: {
      ID: 'textlist',
      TEXT: 'Text List'
    },
    CHECKLIST: {
      ID: 'checklist',
      TEXT: 'Check List'
    },
    HEADING: {
      ID: 'heading',
      TEXT: 'Heading'
    },
    SELECT: {
      ID: 'select',
      TEXT: 'Pick List'
    },
    PHOTO: {
      ID: 'photo',
      TEXT: 'Photograph'
    },
    RADIOGROUP: {
      ID: 'radiogroup',
      TEXT: 'Radio Group'
    },
    PLAINTEXT: {
      ID: 'plaintext',
      TEXT: 'Plain Text'
    },
    TIMESTAMP: {
      ID: 'timestamp',
      TEXT: 'Timestamp'
    },
    PLAINIMAGE: {
      ID: 'plainimage',
      TEXT: 'Plain Image'
    }
  },
  STATUS: {
    COMPLETED: 'COMPLETED',
    DRAFT: 'DRAFT'
  }
};
var RANGES = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  MONTH3: '3month',
  MONTH6: '6month',
  YEAR1: '1year',
  ALL: 'all'
};
module.exports = {
  ADMIN_EMAIL: ADMIN_EMAIL,
  COVID_CONFIG: COVID_CONFIG,
  DASS_STATUS: DASS_STATUS,
  DAYS: DAYS,
  DEFAULT_PREFERENCES: DEFAULT_PREFERENCES,
  DRUG_CONFIG: DRUG_CONFIG,
  ENTITIES: ENTITIES,
  INTERACTIONS: INTERACTIONS,
  IMPERIAL: IMPERIAL,
  METRIC: METRIC,
  OPERATIONS: OPERATIONS,
  PRIVILEGED_USER: PRIVILEGED_USER,
  ALL_PRIVILEGED_USER: ALL_PRIVILEGED_USER,
  RECEIPT_STATUS: RECEIPT_STATUS,
  SLEEP_CONFIG: SLEEP_CONFIG,
  STATUS: STATUS,
  USER_PICTURES: USER_PICTURES,
  USER_STATUS: USER_STATUS,
  BILLING: BILLING,
  ADD: ADD,
  REMOVE: REMOVE,
  ACTIVE: ACTIVE,
  INACTIVE: INACTIVE,
  NOTIFICATIONS: NOTIFICATIONS,
  DOCUMENTS: DOCUMENTS,
  RANGES: RANGES
};